import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router";

import { PublicVisualizationService } from "@/services";

const getIdsFromUrl = (pathname: string | undefined) => {
  if (!pathname) return { propertyId: "" };

  const pathParts = pathname.split("/");
  const propertiesIndex = pathParts.indexOf("properties");
  const propertyId =
    propertiesIndex !== -1 && propertiesIndex + 1 < pathParts.length ? pathParts[propertiesIndex + 1] : "";
  return { propertyId };
};

const sendToChurnZero = (data: Record<string, unknown>) => {
  const xhr = new XMLHttpRequest();
  xhr.open("POST", import.meta.env.VITE_APP_CHURNZERO_URL, true);
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.onerror = () => console.error("ChurnZero tracking request failed");
  xhr.send(JSON.stringify(data));
};

export default function ChurnZero() {
  const location = useLocation();
  const { propertyId } = getIdsFromUrl(location.pathname);
  const [salesforceId, setSalesforceId] = useState<string | null>(null);

  const getPropertySalesforceId = useCallback(async (pId: string) => {
    try {
      const { resp } = await PublicVisualizationService.getPublicProperty(pId);
      if (resp?.salesforceId) {
        setSalesforceId(resp.salesforceId);
      }
    } catch (err) {
      console.error("Error fetching property:", err);
    }
  }, []);

  useEffect(() => {
    if (propertyId) {
      void getPropertySalesforceId(propertyId);
    }
  }, [getPropertySalesforceId, propertyId]);

  useEffect(() => {
    if (salesforceId) {
      const data = {
        appKey: import.meta.env.VITE_APP_CHURNZERO_APP_KEY,
        accountExternalId: salesforceId,
        action: "trackEvent",
        eventName: "pageview",
        quantity: 1,
        contactExternalId: "0",
      };
      sendToChurnZero(data);
    }
  }, [location.pathname, salesforceId]);

  return null;
}
